import { Helmet } from 'react-helmet';

import Jumbotron from '../../components/shared/Jumbotron';
import TabBar from '../../components/shared/TabBar';
import TabFaq from './T01_faq';
import TabQna from './T02_qna';
import TabMyQna from './T03_my-qna';
import jumbotron from '../../assets/images/customer/jumbotron.jpg';

const tabItems = [
  {
    title: '자주묻는질문',
    link: '/고객센터/자주묻는질문',
  },
  {
    title: '문의하기',
    link: '/고객센터/문의하기',
  },
  {
    title: '내 문의사항',
    link: '/고객센터/내-문의사항',
    reload: true,
  },
];

const CSR = () => {
  const tabIndex = tabItems.findIndex((navItem) => navItem.link === decodeURI(window.location.pathname));

  return (
    <div>
      <Helmet>
        <title>풀무원샘물 - 고객센터</title>
        <link
          rel="canonical"
          href="https://www.pulmuonewater.com/%EA%B3%A0%EA%B0%9D%EC%84%BC%ED%84%B0/%EC%9E%90%EC%A3%BC%EB%AC%BB%EB%8A%94%EC%A7%88%EB%AC%B8"
        />
      </Helmet>
      <Jumbotron title="고객센터" subtitle="Customer Center" background={jumbotron} />
      <TabBar items={tabItems} activeIndex={tabIndex} />
      {tabIndex === 0 && <TabFaq />}
      {tabIndex === 1 && <TabQna />}
      {tabIndex === 2 && <TabMyQna />}
    </div>
  );
};

export default CSR;
